import { ProductType } from './../models/product.model';
import { Commission } from './../models/commission.model';
import { QuoteType } from './../models/quote.model';
import { Service } from 'src/app/models/service.model';
import { BulkExecutionError } from './../models/bulk-execution-error.model';
import { AuthService } from './auth.service';
import { Property } from './../models/property.model';
import { SortConfiguration } from './../components/generics/data-table/data-table.component';
import { UtilsService } from './utils.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
        private authService: AuthService
    ) { }

    getProperties(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/propiedades';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        const user = this.authService.getUser();
        if (user?.tipo === 'AGENTE') {
            params['id-agente'] = user.agente?.id;
        } else if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Property[]>(url, { headers, observe: 'response', params });
    }

    getPropertyById(id: ID) {
        return this.http.get<Property>(`/propiedades/${id}`);
    }

    deleteProperty(propertyId: ID) {
        return this.http.delete(`/propiedades/${propertyId}`);
    }

    createProperty(property: Property) {
        return this.http.post<Property>(`/propiedades`, property);
    }

    editProperty(property: Property) {
        return this.http.put<Property>(`/propiedades/${property.id}`, property);
    }

    searchProperty(query: string, ownerId?: ID) {
        const params = { query };
        const user = this.authService.getUser();
        if (user?.tipo === 'AGENTE') {
            params['id-agente'] = user.agente?.id;
        } else if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        if (ownerId) {
            params['propietario-id'] = ownerId;
        }
        return this.http.get<Property[]>(`/propiedades/busqueda`, { params });
    }

    bulkLoad(properties: Property[]) {
        return this.http.post<BulkExecutionError[]>(`/propiedades/creacion-masiva`, properties);
    }

    calculateCommission(alquiler: number, expensas: number, idAgente: ID, servicios: Service[], tipoCotizacion: QuoteType, tipoProducto: ProductType) {
        return this.http.post<Commission>(`/comisiones`, { alquiler, expensas, idAgente, servicios, tipoCotizacion, tipoProducto });
    }

    isAvailable(key: string, value: any) {
        return this.http.post<{ disponible: boolean }>(`/propiedades/disponibilidad`, { campo: key, valor: value });
    }

   isPropertyAvaiable(propertyId: ID) {
      return this.http.get<Property>(`/propiedades/${propertyId}/disponibilidad`);
   }
}
